var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid",staticStyle:{"display":"-webkit-flex","/* Safari */\n  height":"100%","min-height":"100vh","flex-direction":"column"}},[_c('MyHeader'),_c('router-view'),_c('MyFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }